var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialogWrap',{attrs:{"title":"违章处理详情","width":'824px'},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[[_c('el-form',[_c('column-box',{attrs:{"column":2,"source":_vm.source,"list":_vm.list,"labelWidth":130}})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }